import PropTypes from "prop-types";
import React from "react";
import {
  Row,
  Col,
  Alert,
  Card,
  CardBody,
  Container,
  FormFeedback,
  Input,
  Label,
  Form,
} from "reactstrap";

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";

import { ToastContainer } from "react-toastify";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

// actions
import { forgetPassword } from "../../store/actions";

// images
import profile from "../../assets/images/logo-siguniv.png";
import logo from "../../assets/images/logo.svg";

const ForgetPasswordPage = props => {
  document.title = "Mot de passe oublié | SIGUNIV";

  const dispatch = useDispatch();


  
  const ForgotPasswordProperties = createSelector(
    state => state.ForgetPassword,
    forgetPassword => ({
      forgetError: forgetPassword?.forgetError,
      forgetSuccessMsg: forgetPassword?.forgetSuccessMsg,
    })
  );

  const { forgetError, forgetSuccessMsg } = useSelector(ForgotPasswordProperties);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: { email: "" },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Adresse e-mail invalide")
        .required("Veuillez saisir votre adresse e-mail"),
    }),
    onSubmit: async (values) => {
        const email = values.email;
      dispatch(forgetPassword({ email, history: props.router.navigate }));
    },
  });

  return (
    <React.Fragment>
      <div className="home-btn d-none d-sm-block">
        <Link to="/" className="text-dark">
          <i className="bx bx-home h2" />
        </Link>
      </div>

      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-primary-subtle">
                  <Row>
                    <Col xs={7}>
                      <div className="text-primary p-4">
                        <h5 className="text-primary">Mot de passe oublié</h5>
                        <p>Veuillez saisir votre email.</p>
                      </div>
                    </Col>
                    <Col className="col-5 align-self-end">
                      <img src={profile} alt="illustration" className="img-fluid" />
                    </Col>
                  </Row>
                </div>

                <CardBody className="pt-0">
                  <div className="text-center mt-3">
                    <Link to="/">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={logo}
                            alt="logo"
                            className="rounded-circle"
                            height="34"
                          />
                        </span>
                      </div>
                    </Link>
                  </div>

                  <div className="p-2">
                    {forgetError && typeof forgetError === "string" && (
                      <Alert color="danger" className="mt-3">
                        {forgetError}
                      </Alert>
                    )}
                    {forgetSuccessMsg && typeof forgetSuccessMsg === "string" && (
                      <Alert color="success" className="mt-3">
                        {forgetSuccessMsg}
                      </Alert>
                    )}

                    <Form
                      className="form-horizontal"
                      onSubmit={e => {
                        e.preventDefault();
                        validation.handleSubmit();
                      }}
                    >
                      <div className="mb-3">
                        <Label className="form-label">Email</Label>
                        <Input
                          name="email"
                          className="form-control"
                          placeholder="Adresse email"
                          type="email"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.email}
                          invalid={
                            validation.touched.email &&
                            Boolean(validation.errors.email)
                          }
                        />
                        {validation.touched.email && validation.errors.email && (
                          <FormFeedback>{validation.errors.email}</FormFeedback>
                        )}
                      </div>

                      <Row className="mb-3">
                        <Col className="text-end">
                          <button type="submit" className="btn btn-primary w-md">
                            Envoyer le code
                          </button>
                        </Col>
                      </Row>
                    </Form>
                  </div>
                </CardBody>
              </Card>

              <div className="mt-5 text-center">
                <p>
                  Retour à{" "}
                  <Link to="/login" className="font-weight-medium text-primary">
                    Se connecter
                  </Link>
                </p>
                <p>
                  © {new Date().getFullYear()} SIGUNIV. Développé avec{" "}
                  <i className="mdi mdi-heart text-danger" /> par CERTES
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
       <ToastContainer />
    </React.Fragment>
  );
};
export default withRouter(ForgetPasswordPage);
ForgetPasswordPage.propTypes = {
  history: PropTypes.object,
};


